import request from '@/utils/http';
import { unwrapResponse } from '@/utils/http/types';

/**
 * 通用 source 配置（来自外部低代码 / 表单配置）：
 *  - url: 接口路径（必填）
 *  - method: get / post，默认 get
 *  - params: get 方式 query 参数（拼接在 url 上）
 *  - body / data: post 方式请求体
 *  - query / tree: 业务额外参数透传，由调用方使用
 */

/**
 * 按 source 配置发请求，返回解包后的 data（自动穿透 ApiResponse 包装）。
 *
 * 用法：
 *   const list = await fetchSource<Department[]>(source);
 *
 * - url 缺失直接抛错（调用方应兜底）
 * - method 不传时按 get 处理
 * - 业务透传字段（query / tree）不参与请求，由调用方自行处理
 */
export async function fetchSource(source) {
  if (!source?.url) {
    throw new Error('fetchSource: source.url is required');
  }
  const method = (source.method ?? 'get').toLowerCase();
  if (method === 'post') {
    return unwrapResponse(request.post(source.url, source.body ?? source.data ?? {}));
  }
  return unwrapResponse(request.get(source.url, {
    params: source.params
  }));
}